import { useState } from 'react';
import './App.css';

function App() {
  const handleUpdate = () => {
    // Redirect to Play Store - replace with your actual app link
    window.open('https://play.google.com/store/apps/details?id=in.i.recharge', '_blank');
  };

  return (
    <div className="App">
      <div className="mobile-container">
        {/* Simple Header */}
        <header className="simple-header">
          <h1 className="app-name">iRecharge</h1>
        </header>

        {/* Main Content */}
        <main className="simple-content">
          {/* Simple Image */}
          <div className="simple-image">
            <div className="image-placeholder">
              <span className="image-icon">📱</span>
            </div>
          </div>

          {/* Two Lines of Text */}
          <div className="simple-text">
            <h2 className="main-line">New Version Available</h2>
            <p className="sub-line">Update for better experience</p>
          </div>

          {/* Red Update Button */}
          <button 
            className="update-btn"
            onClick={handleUpdate}
          >
            Update Now
          </button>

          {/* Optional: Small note */}
          <p className="small-note">Tap update to go to Play Store</p>
        </main>

        {/* Simple Footer */}
        <footer className="simple-footer">
          <p>v2.0 • Available now</p>
        </footer>
      </div>
    </div>
  );
}

export default App;